export default __webpack_public_path__ + "static/logo-white-38809c4997882d849b4494decc9be66d.png";